import { IMediaItem } from "services/KnowfullyAdminClient";
import { TinyMCEPluginBase } from "types/common-types";
import { MediaLibraryDialogView } from "pages/MediaLibraryPage/MediaLibraryDialogView";
import { MediaType } from "utils/mediaUtils";

export const MediaLibraryPluginView = ({
  editor,
  onClose,
}: TinyMCEPluginBase) => {
  const onClickMediaLibraryItem = (mediaLibraryItem: IMediaItem) => {
    editor.insertContent(
      `<img src="${mediaLibraryItem.fileUrl}" width="${mediaLibraryItem.width}" height="${mediaLibraryItem.height}" alt="${mediaLibraryItem.alternativeText}"/>`
    );

    onClose();
  };

  return (
    <MediaLibraryDialogView
      onClickMediaLibraryItem={onClickMediaLibraryItem}
      options={[MediaType.IMAGE]}
    />
  );
};
